import { Pipe, PipeTransform } from '@angular/core';
import { CommonDataSetAction, ItemAttrListDataSet } from '@mri/types';

@Pipe({
  name: 'tableDataSetOnlyIcon',
})
export class TableDataSetOnlyIconPipe implements PipeTransform {

  transform(actions: CommonDataSetAction, prop: ItemAttrListDataSet): unknown {
    if(!actions.onlyIcon) return false;

    return actions.onlyIcon(prop)
  }

}
